// src/components/Footer.js
import React from "react";
import { FaLinkedin } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-[#F6F8D0] text-black py-6 flex flex-col items-center justify-center w-full">
      <a
        href="https://www.linkedin.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-2xl mb-2 hover:text-[#234C2C]"
      >
        <FaLinkedin />
      </a>
      <p className="text-sm">© 2025 Reverra. All rights reserved.</p>
    </footer>
  );
}
